import { render } from "./LocaleDateTime.vue?vue&type=template&id=6c67cb2d"
import script from "./LocaleDateTime.vue?vue&type=script&lang=js"
export * from "./LocaleDateTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__